import { PlantEntity } from "@/property/shared/entities/PlantEntity";
import { Form } from "@/shared/form/Form";

export class CreatePlantForm extends Form<PlantEntity> {
  protected definition = {};
}
